<template>
    <div>
        <commonPartsHeader />
        <div class="container-fluid !px-0">
            <div class="pt-[100px] mobile:px-[10px] laptop:px-[20px]">
                <div class="text-center laptop:my-6 my-6 mobile:my-3 flex justify-center items-center">
                    <div class="text-center w-full px-[30px]">
                        <h2
                            class="mb-0 font-bold font-roboto mobile:text-[20px] laptop:text-[28px] largeDesktop:text-[30px] text-gray-900"
>
                            Common Parts & Service Pricing
                        </h2>
                        <p class="mb-0 font-normal font-roboto mobile:text-base desktop:text-[20px] text-[#666666]">
                            Below is a list of the most common parts and services by trade.
                        </p>
                        <p class="mb-0 font-normal font-roboto mobile:text-base desktop:text-[20px] text-[#666666]">
                            The prices shown represent the maximum amount a contractor can charge a customer for a job.
                        </p>
                    </div>
                </div>
                <div
                    class="mt-6 laptop:mt-8 p-[10px] laptop:p-[30px] relative rounded-[20px] border border-gray-500 shadow-sm mobile:!bg-transparent tablet:bg-white laptop:!bg-white/50 mobile:min-h-[55vh] tablet:min-h-[65vh] laptop:min-h-[500px]"
>
                    <!-- only for laptop/desktop Devices -->
                    <div class="grid-cols-1 laptop:grid-cols-3 gap-[30px] largeDesktop:gap-[40px] mobile:hidden laptop:grid">
                        <div
v-for="part in partsData" :key="part.title"
                            class="font-roboto rounded-[20px] p-[20px] shadow-[0px_0px_13px_-9px_#000000] bg-white"
>
                            <div class="flex justify-start items-center gap-2 pb-[20px]">
                                <img
:src="require(`../../assets/images/${part.icon}.png`)" alt="Logo"
                                    class="w-[50px] h-[50px] object-contain"
>
                                <h4 class="font-bold text-[20px] mb-0 text-[#333333]">
{{ part.title }}
</h4>
                            </div>
                            <!-- head -->
                            <div
                                class="flex items-center justify-between p-[10px] w-full rounded-[10px] shadow-[0px_0px_12px_-10px_#000000] border border-white bg-[#BA90C6]"
>
                                <span class="font-medium text-[16px] text-white">
                                    Items
                                </span>
                                <span class="font-medium text-[16px] text-white">
                                    Maximum Price
                                </span>
                            </div>
                            <!-- body -->
                            <div class="flex flex-col gap-1 mt-2">
                                <div
v-for="item in part.list" :key="item.item"
                                    class="flex justify-between p-[10px] w-full rounded-[10px] bg-[#F1F1F180]/50"
                                    :class="item.itemTag ? 'items-start' : 'items-center'"
>
                                    <div>
                                        <p class="capitalize m-0 font-normal text-[14px] text-[#333333]">
                                            {{ item.item }}
                                        </p>
                                        <p
v-if="item.itemTag"
                                            class="m-0 font-normal text-[13px] leading-tight text-[#666666]"
>
                                            {{ item.itemTag }}
                                        </p>
                                    </div>
                                    <p class="min-w-[80px] text-right m-0 font-normal text-[14px] text-[#333333]">
                                        ${{ item.price }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- accordians only for Mob/Tab Devices -->
                    <div
id="accordionExample"
                        class="accordion flex-col gap-3 w-full mobile:flex laptop:hidden"
>
                        <div
v-for="(item, index) in partsData"
                            :key="index" class="accordion-item font-roboto rounded-[20px] p-[20px] shadow-[0px_0px_13px_-9px_#000000] bg-white " :class="{ '': activeIndex === index }"
>
                            <h2
:id="'heading' + index" class="accordion-header flex justify-between items-center"
                                @click="activeIndex = activeIndex === index ? null : index"
>
                                <div class="flex justify-start items-center gap-2">
                                    <img
:src="require(`../../assets/images/${item.icon}.png`)" alt="Logo"
                                        class="w-[50px] h-[50px] object-contain"
>
                                    <h4 class="font-bold text-[20px] mb-0 text-[#333333]">
{{ item.title }}
</h4>
                                </div>
                                <button
:class="[
                                    'accordion-button min-h-[34px] min-w-[34px] max-h-[34px] max-w-[34px] flex justify-center items-center border-[#EFEFEF] bg-transparent !rounded-full focus:!outline-none focus:!shadow-[0px_0px_20px_-10px_#000000] !shadow-[0px_0px_20px_-10px_#000000] after:hidden relative !p-0',
                                    activeIndex === index ? 'border-b-[1px] border-[#EFEFEF] border-solid' : '!border-0'
                                ]" type="button" :aria-expanded="activeIndex === index ? 'true' : 'false'"
>
                                    <img
src="../../assets/images/arrow-accordian.png" alt="icon" :class="[
                                        ' transition-transform w-[25px] h-[25px]',
                                        activeIndex === index ? '' : 'rotate-180'
                                    ]"
>
                                    <!-- <font-awesome-icon icon="angle-down"  /> -->
                                </button>
</h2>
                            <transition name="accordion" @enter="enter" @leave="leave">
                                <div v-if="activeIndex === index" class="accordion-body !p-0">
                                    <div class="w-full pt-[20px]">
                                        <!-- head -->
                                        <div
                                            class="flex items-center justify-between p-[10px] w-full rounded-[10px] shadow-[0px_0px_12px_-10px_#000000] border border-white bg-[#BA90C6]"
>
                                            <span class="font-medium text-[16px] text-white">
                                                Items
                                            </span>
                                            <span class="font-medium text-[16px] text-white">
                                                Maximum Price
                                            </span>
                                        </div>
                                        <!-- body -->
                                        <div class="flex flex-col gap-1 mt-2">
                                            <div
v-for="item in item.list" :key="item.item"
                                                class="flex justify-between p-[10px] w-full rounded-[10px] bg-[#F1F1F180]/50"
                                                :class="item.itemTag ? 'items-start' : 'items-center'"
>
                                                <div>
                                                    <p class="capitalize m-0 font-normal text-[14px] text-[#333333]">
                                                        {{ item.item }}
                                                    </p>
                                                    <p
v-if="item.itemTag"
                                                        class="m-0 font-normal text-[13px] leading-tight text-[#666666]"
>
                                                        {{ item.itemTag }}
                                                    </p>
                                                </div>
                                                <p
                                                    class="min-w-[80px] text-right m-0 font-normal text-[14px] text-[#333333]"
>
                                                    ${{ item.price }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
                <FooterPartial />
            </div>
        </div>
    </div>
</template>
<script>
import commonPartsHeader from "../../components/layouts/header/commonPartsHeader.vue";
import FooterPartial from "../../components/layouts/footer/FooterPartial";

export default {
    components: {
        commonPartsHeader,
        FooterPartial
    },
    data() {
        return {


            partsData: [
                {
                    title: "HVAC",
                    icon: "bundleicon-01",
                    list: [
                        // { item: "Thermostat", price: "340.00" },
                        { item: "Evaluation Fee", price: "119.00" },
                        { item: "Tune Up / Maintenance Fee", price: "124.99" },
                        { item: "Blower Motor", price: "700.00" },
                        { item: "Capacitor", price: "250.00" },
                        { item: "Electrical Connections", price: "273.00" },
                        { item: "Contactor", price: "350.00" },
                        { item: "Control Board", price: "567.00" },
                        { item: "Evaporator Coil", price: "2,500.00" },
                        { item: "Dual Capacitor", price: "232.00" },
                        { item: "Circuit Board", price: "477.00" },
                        { item: "Relay", price: "270.00" },
                        { item: "Sequencer", price: "204.00" },
                        { item: "Limit Switch", price: "229.00" },
                        { item: "Basic Thermostat", price: "260.00" },
                        { item: "Drain Pan", price: "357.00" },
                        { item: "Ignitor", price: "274.00" },
                        { item: "Condenser Fan Motor", price: "650.00" },

                        { item: "Compressor Capacitor", price: "250.00" },
                        { item: "TXV", price: "650.00" },
                        { item: "Condensate Line", price: "150.00" },
                        { item: "Coil – Condensing", price: "1,300.00" },
                        { item: "Compressor", price: "1,800.00" },
                        { item: "Door Switch", price: "200.00" }


                    ]
                },
                {
                    title: "Electric",
                    icon: "bundleicon-02",
                    list: [
                    { item: "Evaluation Fee", price: "119.00" },
                        { item: "Circuit Breakers", price: "382.00" },
                        { item: "Switches", price: "303.00" },
                        { item: "Wiring", price: "574.00" },
                        { item: "Outlets", price: "160.00" },
                        { item: "Receptacles", price: "160.00" },
                        { item: "Electrical Maintenance", price: "266.00" },
                        { item: "GFI Circuit Breakers", price: "328.00" },
                        { item: "Ceiling Fans", price: "419.00" },
                        { item: "Junction Box", price: "454.00" },
                        { item: "Circuit Breaker Panel", price: "554.00" },
                        { item: "Internal Hard Wired Circuits", price: "600.00" },
                        { item: "Light Fixtures", price: "49.00" },
                        { item: "Door Bells", price: "234.00" },
                        { item: "Breaker panels and subpanels", price: "1,507.00", itemTag: "(must be attached to the home and failed due to normal wear and tear)" }
                    ]
                },

                {
                    title: "Plumbing",
                    icon: "bundleicon-03",
                    list: [
                        { item: "Evaluation Fee", price: "119.00" },
                        { item: "Tune Up / Maintenance Fee", price: "350.00" },
                        { item: "v2v Leak Repair", price: "450.00" },
                        { item: "Stoppage Removal", price: "350.00" },
                        { item: "Faucet Mechanism", price: "300.00" },
                        { item: "Interior Stoppage Removal", price: "350.00" },
                        { item: "Toilet Tank Mechanism", price: "250.00" },
                        { item: "Toilet Wax Ring", price: "300.00" },
                        { item: "Angle Stop", price: "250.00" },
                        { item: "Replace Water Heater", price: "2,500.00" },
                        { item: "Shower Valve", price: "531.00" },
                        // { item: "Maintenance", price: "179.49" },
                        { item: "Hose Bib", price: "300.00" },
                        { item: "Fixture Mechanism", price: "300.00" },
                        { item: "Drain Valve", price: "216.00" },
                        { item: "Pressure Valve", price: "149.00" },
                        // { item: "Maintenance Fee", price: "273.51" },
                        // { item: "Stoppage Removal 2", price: "350.00" },
                        { item: "Leak Search", price: "447.00" },
                        { item: "Tub Valve", price: "795.00" },
                        { item: "Water Heater Diagnostic", price: "402.00" }
                    ]
                }
            ],
            activeIndex: null,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.activeIndex = 0;
        });
    },
    methods: {
        enter(el) {
            el.style.maxHeight = '0';
            el.style.paddingTop = '0';
            el.style.paddingBottom = '0';
            el.style.overflow = 'hidden';

            const fullHeight = el.scrollHeight;
            const computedStyle = getComputedStyle(el);
            const paddingTop = computedStyle.paddingTop;
            const paddingBottom = computedStyle.paddingBottom;

            requestAnimationFrame(() => {
                el.style.transition = 'max-height 0.5s ease, padding 0.5s ease';
                el.style.maxHeight = fullHeight + 'px';
                el.style.paddingTop = paddingTop;
                el.style.paddingBottom = paddingBottom;
            });

            el.addEventListener('transitionend', () => {
                el.style.maxHeight = 'none';
                el.style.transition = '';
                el.style.overflow = '';
            }, { once: true });
        },
        leave(el) {
            const computedStyle = getComputedStyle(el);
            const paddingTop = computedStyle.paddingTop;
            const paddingBottom = computedStyle.paddingBottom;

            el.style.maxHeight = el.scrollHeight + 'px';
            el.style.paddingTop = paddingTop;
            el.style.paddingBottom = paddingBottom;
            el.style.overflow = 'hidden';

            requestAnimationFrame(() => {
                el.style.transition = 'max-height 0.4s ease, padding 0.3s ease';
                el.style.maxHeight = '0';
                el.style.paddingTop = '0';
                el.style.paddingBottom = '0';
            });
        }
    },
};
</script>
<style>
.accordion-button {
    transition: border-color 0.2s ease;
}
.accordion-item:first-of-type , .accordion-item:last-of-type{
    border-radius: 20px !important;
}
</style>